import React, {  useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";

import Aboutus from "./staticContent/Aboutus";
import GeneralTerms from "./staticContent/GeneralTerms";
import Kyc from "./staticContent/Kyc";
import PrivacyPolicy from "./staticContent/PrivacyPolicy";
import RulesRegulation from "./staticContent/RulesRegulation";
import ResponsibleGaming from "./staticContent/ResponsibleGaming";
import AuthContext from "../context/AuthContext";
import Tab from "./socialTab/Tab";


const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className={isReadMore ? "text full-text" : "text "}>
      {isReadMore ? text.slice(0, 300) : text}
      <span
        onClick={toggleReadMore}
        className="read-or-hide"
        style={{ color: "black" }}
      >
        {isReadMore ? "Show More" : " Show Less"}
      </span>
    </p>
  );
};

const FooterSection = () => {
  let { open, setOpen, content, slug, setSlug, handleContentToggle } =
    useContext(AuthContext);
  const { t } = useTranslation();
  const [showImg, setShowImg] = useState(true);
  const navigate = useNavigate();
  

  return (
    <>
      <div className="site-footer-section" style={{
        padding: '20px 10px 70px',
        textAlign: 'center',
        backgroundColor: '#ededed',
      }}>
        {/* Footer Links with Pipe Separators */}
        <div className="site-footer-links" style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '8px',
          marginBottom: '20px',
          fontSize: '14px',
        }}>
          <Link
            to="javascript:void(0)"
            style={{ textDecoration: 'none', color: '#000' }}
            onClick={() => {
              handleContentToggle();
              setSlug("privacy");
            }}
          >
            Privacy Policy
          </Link>
          <span style={{ color: '#000' }}>|</span>
          <Link
            to="javascript:void(0)"
            style={{ textDecoration: 'none', color: '#000' }}
            onClick={() => {
              handleContentToggle();
              setSlug("kyc");
            }}
          >
            KYC
          </Link>
          <span style={{ color: '#000' }}>|</span>
          <Link
            to="javascript:void(0)"
            style={{ textDecoration: 'none', color: '#000' }}
            onClick={() => {
              handleContentToggle();
              setSlug("term");
            }}
          >
            Terms and Conditions
          </Link>
          <span style={{ color: '#000' }}>|</span>
          <Link
            to="javascript:void(0)"
            style={{ textDecoration: 'none', color: '#000' }}
            onClick={() => {
              handleContentToggle();
              setSlug("rules");
            }}
          >
            Rules and Regulations
          </Link>
          <span style={{ color: '#000' }}>|</span>
          <Link
            to="javascript:void(0)"
            style={{ textDecoration: 'none', color: '#000' }}
            onClick={() => {
              handleContentToggle();
              setSlug("responsible");
            }}
          >
            Responsible Gambling
          </Link>
        </div>

        {/* iOS Download Button */}
        <div className="site-footer-download" style={{
          display: 'inline-block',
          width: '153.53px',
          height: '42.66px',
          background: 'linear-gradient(180deg, #3a3a3a 0%, #1a1a1a 50%, #000 100%)',
          borderRadius: '10px',
          cursor: 'pointer',
          border: '1px solid #000',
          boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
          boxSizing: 'border-box',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            height: '100%',
            gap: '10px',
            padding: '0 14px',
          }}>
            <svg width="34" height="34" viewBox="0 0 24 24" fill="white">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <div style={{ textAlign: 'left' }}>
              <div style={{ color: '#fff', fontSize: '14px', fontWeight: '400', lineHeight: '1' }}>Download</div>
              <div style={{ color: '#fff', fontSize: '18px', fontWeight: '700', lineHeight: '1.2' }}>iOS APP</div>
            </div>
          </div>
        </div>
      </div>


      {content && (
        <div className="frame-wrap">
          <div className="news-wrap news-wrap-frame">
            {slug === "about" && <Aboutus />}
            {slug === "term" && <GeneralTerms />}
            {slug === "kyc" && <Kyc />}
            {slug === "privacy" && <PrivacyPolicy />}
            {slug === "rules" && <RulesRegulation />}
            {slug === "responsible" && <ResponsibleGaming />}

            <footer>
              <Link
                to="#"
                className="btn-send"
                onClick={() => {
                  handleContentToggle();
                  setSlug("");
                }}
              >
                CLOSE
              </Link>
            </footer>
          </div>
        </div>
      )}



    </>
  );
};

export default FooterSection;